import api from 'api';
const refundAllUrl = '/api/events/:eventId/refund/merchandises';
const refundItemUrl = '/api/refund/merchandises';

export default {
    refund: (eventId, params) => params ? api.post({path: refundItemUrl, params: [params]}) : api.get({path:refundAllUrl.replace(':eventId', eventId), params: [params]})
};